module.exports = [
  {
    category: 'vital',
    id: 'etco2',
    key: 'ETCO2',
    name: { en: 'ETCO2', es: 'ETCO2' },
    order: 6,
    possibleValues: null,
    type: 'number',
    defaultValue: 38
  },
  {
    category: 'stance',
    key: 'ANIMATION_REPEAT_DELAY',
    name: { en: 'Repeats every', es: 'Repite cada' },
    order: 7,
    type: 'number',
    id: 'animationDelay',
    units: 'sec'
  },
  {
    category: 'labResult',
    key: 'GLUCOSE',
    name: { en: 'Glucose', es: 'Glucosa' },
    order: 7,
    possibleValues: null,
    type: 'number',
    defaultValue: 80,
    id: 'glucose'
  },
  {
    category: 'eyeState',
    id: 'rightEye',
    name: { en: 'Right Eye', es: 'Ojo derecho' },
    key: 'RIGHT_EYE',
    order: 2,
    possibleValues: [
      { key: 'NORMAL', label: { en: 'Normal', es: 'Normal' } },
      { key: 'DILATED', label: { en: 'Dilated', es: 'Dilatado' } },
      {
        key: 'CONSTRICTED',
        label: { en: 'Constricted', es: 'restringido' }
      }
    ],
    type: 'enum',
    defaultValue: 'NORMAL'
  },
  {
    category: 'waveform',
    id: 'etco2Rhythm',
    name: { en: 'ETCO2 Waveform', es: 'Formas de onda del ETCO2' },
    key: 'ETCO2_RHYTHM',
    order: 9,
    possibleValues: [
      {
        key: 'NORMAL',
        label: { en: 'Normal', es: 'Normal' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/etco2/ETCO2_NORMAL.png'
        }
      },
      {
        key: 'APNEA',
        label: { en: 'Apnea', es: 'Apnea' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/etco2/ETCO2_APNEA.png'
        }
      },
      {
        key: 'BRONCHOSPASM',
        label: { en: 'Bronchospasm', es: 'Broncoespasmo' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/etco2/ETCO2_BRONCHOSPASM.png'
        }
      },
      {
        key: 'HYPERVENTILATION',
        label: { en: 'Hyperventilation', es: 'Hiperventilaci?n' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/etco2/ETCO2_HYPERVENTILATION.png'
        }
      },
      {
        key: 'HYPOVENTILATION',
        label: { en: 'Hypoventilation', es: 'Hipoventilaci?n' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/etco2/ETCO2_HYPOVENTILATION.png'
        }
      }
    ],
    type: 'enum',
    defaultValue: 'NORMAL'
  },
  {
    id: 'BP',
    key: 'BP',
    name: { en: 'BP', es: 'Presi?n arterial' },
    order: 2,
    possibleValues: null,
    type: 'string',
    defaultValue: '120/80'
  },
  {
    category: 'gameState',
    key: 'GAME_TIME',
    name: { en: 'Game Time', es: 'Tiempo de juego' },
    type: 'number',
    id: 'GameTime'
  },
  {
    category: 'vital',
    id: 'BPSystolic',
    key: 'BLOOD_PRESSURE_SYSTOLIC',
    name: { en: 'Systolic', es: 'Presi?n arterial sist�lica' },
    order: 2,
    possibleValues: null,
    type: 'number',
    defaultValue: 120
  },
  {
    category: 'sound',
    name: { en: 'Heart Sounds', es: 'Sonidos del coraz�n' },
    key: 'HEART_SOUNDS',
    possibleValues: [
      {
        key: 'PANSYSTOLIC_MURMUR',
        label: { en: 'Pansystolic Murmur', es: 'Pansystolic Murmur' }
      },
      {
        key: 'NORMAL_SPLIT_SECOND_SOUND',
        label: {
          en: 'Normal Split Second Sound',
          es: 'Normal Split Second Sound'
        }
      },
      {
        key: 'NORMAL_SPLIT_S1',
        label: { en: 'Normal Split S1', es: 'Normal Split S1' }
      },
      {
        key: 'LATE_SYSTOLIC_MURMUR',
        label: { en: 'Late Systolic Murmur', es: 'Late Systolic Murmur' }
      },
      {
        key: 'EJECTION_CLICK',
        label: { en: 'Ejection Click', es: 'Ejection Click' }
      },
      {
        key: 'OPENING_SNAP',
        label: { en: 'Opening Snap', es: 'Opening Snap' }
      },
      {
        key: 'DIASTOLIC_RUMBLE',
        label: { en: 'Diastolic Rumble', es: 'Diastolic Rumble' }
      },
      { key: 'S3', label: { en: 'S3', es: 'S3' } },
      {
        key: 'PLEURAL_FRICTION',
        label: { en: 'Pleural friction', es: 'Pleural friction' }
      },
      { key: 'S4', label: { en: 'S4', es: 'S4' } },
      {
        key: 'EARLY_SYSTOLIC_MURMUR',
        label: { en: 'Early Systolic Murmur', es: 'Early Systolic Murmur' }
      },
      {
        key: 'NORMAL',
        label: { en: 'NormalHeart', es: 'NormalHeart' }
      }
    ],
    type: 'enum',
    defaultValue: 'NORMAL',
    id: 'heartSounds'
  },
  {
    name: { en: 'Assessment Locations', es: 'Assessment Locations' },
    key: 'PHYSICAL_ASSESSMENT_LOCATIONS',
    possibleValues: require('./physicalAssessmentLocations'),
    type: 'enum',
    defaultValue: 'HEAD',
    id: 'physicalAssessmentLocations'
  },
  {
    category: 'vital',
    id: 'BPDiastolic',
    key: 'BLOOD_PRESSURE_DIASTOLIC',
    name: { en: 'Diastolic', es: 'Presi?n arterial diast�lica' },
    order: 2.5,
    possibleValues: null,
    type: 'number',
    defaultValue: 80
  },
  {
    category: 'sound',
    name: { en: 'Breath Sounds', es: 'Sonidos de aliento' },
    key: 'BREATH_SOUNDS',
    possibleValues: [
      {
        key: 'WHEEZING_1',
        label: { en: 'Wheezing 1', es: 'Wheezing 1' }
      },
      {
        key: 'NORMAL_VESICULAR',
        label: { en: 'Normal vesicular', es: 'Normal vesicular' }
      },
      {
        key: 'BREATH_SOUND_WHEEZING',
        label: { en: 'Breath_sound_Wheezing', es: 'Breath_sound_Wheezing' }
      },
      {
        key: 'INSPIRATORY_STRIDOR',
        label: { en: 'Inspiratory stridor', es: 'Inspiratory stridor' }
      },
      { key: 'WHEEZING', label: { en: 'Wheezing', es: 'Wheezing' } },
      {
        key: 'COARSE_CRACKLES',
        label: { en: 'Coarse crackles', es: 'Coarse crackles' }
      }
    ],
    type: 'enum',
    defaultValue: 'NORMAL_VESICULAR',
    id: 'breathSounds'
  },
  {
    category: 'vital',
    id: 'heartRate',
    key: 'HEART_RATE',
    name: { en: 'Heart Rate', es: 'Ritmo cardiaco' },
    order: 1,
    possibleValues: null,
    type: 'number',
    defaultValue: 70
  },
  {
    category: 'waveform',
    id: 'heartRhythm',
    name: { en: 'EKG Waveform', es: 'Ritmos card?acos' },
    key: 'HEART_RHYTHM',
    order: 8,
    possibleValues: [
      {
        key: 'NORMAL_SINUS',
        label: { en: 'Normal Sinus', es: 'Seno normal' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_NORMAL_SINUS.png'
        }
      },
      {
        key: 'FIRST_DEGREE_BLOCK',
        label: { en: '1st Degree Block', es: 'Bloque de primer grado' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_FIRST_DEGREE_BLOCK.png'
        }
      },
      {
        key: 'SECOND_DEGREE_BLOCK_TYPE_1',
        label: {
          en: '2nd Degree Block Type 1',
          es: 'Bloque de 2do grado tipo 1'
        },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_SECOND_DEGREE_BLOCK_TYPE_1.png'
        }
      },
      {
        key: 'SECOND_DEGREE_BLOCK_TYPE_2',
        label: {
          en: '2nd Degree Block Type 2',
          es: 'Bloque de 2do grado tipo 2'
        },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_SECOND_DEGREE_BLOCK_TYPE_2.png'
        }
      },
      {
        key: 'THIRD_DEGREE_BLOCK',
        label: { en: '3rd Degree Block', es: 'Bloque de 3er grado' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_THIRD_DEGREE_BLOCK.png'
        }
      },
      {
        key: 'ASYSTOLE',
        label: { en: 'Asystole', es: 'Asistolia' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_ASYSTOLE.png'
        }
      },
      {
        key: 'ATRIAL_FLUTTER',
        label: { en: 'Atrial Flutter', es: 'Aleteo auricular' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_ATRIAL_FLUTTER.png'
        }
      },
      {
        key: 'ATRIAL_FIBRILLATION',
        label: { en: 'Atrial Fibrillation', es: 'Fibrilaci?n auricular' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_ATRIAL_FIBRILLATION.png'
        }
      },
      {
        key: 'SINUS_BRADYCARDIA',
        label: { en: 'Sinus Bradycardia', es: 'Bradicardia sinusal' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_SINUS_BRADYCARDIA.png'
        }
      },
      {
        key: 'SINUS_TACHYCARDIA',
        label: { en: 'Sinus Tachycardia', es: 'Taquicardia sinusal' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_SINUS_TACHYCARDIA.png'
        }
      },
      {
        key: 'SUPRAVENTRICULAR_TACHYCARDIA',
        label: {
          en: 'Supraventricular Tachycardia',
          es: 'Taquicardia supraventricular'
        },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_SUPRA_VENTRICULAR_TACHYCARDIA.png'
        }
      },
      {
        key: 'TORSADES_DE_POINTES',
        label: { en: 'Torsades de Pointes', es: 'Torsades de Pointes' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_TORSADES_DE_POINTES.png'
        }
      },
      {
        key: 'VENTRICULAR_FIBRILLATION',
        label: {
          en: 'Ventricular Fibrillation',
          es: 'La fibrilaci?n ventricular'
        },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_VENTRICULAR_FIBRILLATION.png'
        }
      },
      {
        key: 'VENTRICULAR_TACHYCARDIA',
        label: {
          en: 'Ventricular Tachycardia',
          es: 'Taquicardia ventricular'
        },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_VENTRICULAR_TACHYCARDIA.png'
        }
      },
      {
        key: 'CAPTURED_PACING',
        label: { en: 'Pacing with Capture', es: 'Estimulaci�n con captura' },
        picture: {
          url: 'https://s3-us-west-2.amazonaws.com/assets.vrpatients.net/waveforms/heart/EKG_CAPTURED_PACING.png'
        }
      }
    ],
    type: 'enum',
    defaultValue: 'NORMAL_SINUS'
  },
  {
    category: 'eyeState',
    id: 'leftEye',
    key: 'LEFT_EYE',
    name: { en: 'Left Eye', es: 'Ojo izquierdo' },
    order: 1,
    possibleValues: [
      { key: 'NORMAL', label: { en: 'Normal', es: 'Normal' } },
      { key: 'DILATED', label: { en: 'Dilated', es: 'Dilatado' } },
      {
        key: 'CONSTRICTED',
        label: { en: 'Constricted', es: 'restringido' }
      }
    ],
    type: 'enum',
    defaultValue: 'NORMAL'
  },
  {
    category: 'vital',
    id: 'respiratoryRate',
    key: 'RESPIRATORY_RATE',
    name: { en: 'RR', es: 'RR' },
    order: 4,
    possibleValues: null,
    type: 'number',
    defaultValue: 15
  },
  {
    category: 'vital',
    id: 'temperature',
    key: 'TEMPERATURE',
    name: { en: 'Temperature', es: 'Temperatura' },
    order: 3,
    possibleValues: null,
    type: 'number',
    defaultValue: 98.6
  },
  {
    category: 'stance',
    id: 'position',
    name: { en: 'Position', es: 'Posici?n' },
    key: 'POSITION',
    order: 5,
    possibleValues: [
      {
        key: 'SIT',
        label: {
          en: 'Seated facing forward',
          es: 'Sentado mirando hacia adelante'
        }
      },
      { key: 'LAY', label: { en: 'Supine', es: 'Acostado' } },
      { key: 'FOWLER', label: { en: 'Fowler', es: 'Fowler' } },
      { key: 'PRONE', label: { en: 'Prone', es: 'Propensa' } },
      { key: 'SIDE', label: { en: 'Side', es: 'Lado' } }
    ],
    type: 'enum',
    defaultValue: 'SIT'
  },
  {
    category: 'stance',
    id: 'animation',
    key: 'ANIMATION',
    name: { en: 'Behavior', es: 'Comportamiento' },
    order: 3,
    possibleValues: [
      {
        key: 'STATIONARY',
        label: { en: 'Stationary' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER', 'PRONE', 'SIDE' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          nonGastricDistension: true
        }
      },
      {
        key: 'IDLE',
        label: { en: 'Idle' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER', 'PRONE', 'SIDE' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          nonGastricDistension: true
        }
      },
      {
        key: 'AGGRESSIVE',
        label: { en: 'Aggressive' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: true,
          isOneShot: true,
          isRepeating: true
        }
      },
      {
        key: 'CRYING',
        label: { en: 'Crying' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'UNCONSCIOUS',
        label: { en: 'Unconscious' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'HYPOTHERMIA',
        label: { en: 'Hypothermia' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'TOURETTES',
        label: { en: 'Tourettes' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: true,
          isOneShot: true,
          isRepeating: true
        }
      },
      {
        key: 'DEPRESSED',
        label: { en: 'Depressed' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'DISTRESSED_BREATHING',
        label: { en: 'Distressed Breathing' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'TUG_NECKLINE',
        label: { en: 'Tug Neckline' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'EXCESSIVE_ITCH',
        label: { en: 'Excessive Itch' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          nonGastricDistension: true
        }
      },
      {
        key: 'ARM_SUPPORT_LT',
        label: { en: 'Arm Support Left' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'ARM_SUPPORT_RT',
        label: { en: 'Arm Support Right' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'SUPINE',
        label: { en: 'Supine' },
        meta: {
          compatiblePositions: [ 'LAY' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'CUPPING_EAR',
        label: { en: 'Cupping Ear' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'CLUTCH_CHEST',
        label: { en: 'Clutch Chest' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'CHOKING',
        label: { en: 'Choking' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'COUGHING',
        label: { en: 'Coughing' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: true,
          isOneShot: true,
          isRepeating: true,
          oneShotValue: 'COUGH',
          nonGastricDistension: true
        }
      },
      {
        key: 'COUGHING_BLAST',
        label: { en: 'Coughing Blast' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: true,
          isOneShot: true,
          isRepeating: true,
          oneShotValue: 'COUGH_BLAST',
          nonGastricDistension: true
        }
      },
      {
        key: 'ROCKING',
        label: { en: 'Rocking' },
        meta: {
          compatiblePositions: [ 'SIT' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'TRIPOD_MILD',
        label: { en: 'Tripod Mild' },
        meta: {
          compatiblePositions: [ 'SIT' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'TRIPOD_EXTREME',
        label: { en: 'Tripod Extreme' },
        meta: {
          compatiblePositions: [ 'SIT' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'MILD_SEIZURE',
        label: { en: 'Mild Seizure' },
        meta: {
          compatiblePositions: [ 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'GRAND_MAL_SEIZURE',
        label: { en: 'Grand Mal Seizure' },
        meta: {
          compatiblePositions: [ 'LAY' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'WIGGLE_FINGERS',
        label: { en: 'Wiggle Fingers' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'WIGGLE_TOES',
        label: { en: 'Wiggle Toes' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          nonGastricDistension: true
        }
      },
      {
        key: 'DRY_HEAVE',
        label: { en: 'Dry Heave' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'FOCAL_SEIZURE',
        label: { en: 'Focal Seizure' },
        meta: {
          compatiblePositions: [ 'SIT' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'HOLD_HEAD',
        label: { en: 'Hold Head' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'NERVOUS_TWITCH',
        label: { en: 'Nervous Twitch' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'RUB_CHEST',
        label: { en: 'Rub Chest' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'STOMACH_PAIN',
        label: { en: 'Stomach Pain' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          nonGastricDistension: true
        }
      },
      {
        key: 'DECEREBRATE_SEIZURE',
        label: { en: 'Decerebrate Seizure' },
        meta: {
          compatiblePositions: [ 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'DECORTICATE_SEIZURE',
        label: { en: 'Decorticate Seizure' },
        meta: {
          compatiblePositions: [ 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_ABDOMEN_MILD',
        label: { en: 'In Pain Abdomen Mild' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          nonGastricDistension: true
        }
      },
      {
        key: 'IN_PAIN_ABDOMEN_MODERATE',
        label: { en: 'In Pain Abdomen Moderate' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          nonGastricDistension: true
        }
      },
      {
        key: 'IN_PAIN_ARM_MILD_LT',
        label: { en: 'In Pain Arm Mild Left' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_ARM_MILD_RT',
        label: { en: 'In Pain Arm Mild Right' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_ARM_MODERATE_LT',
        label: { en: 'In Pain Arm Moderate Left' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_ARM_MODERATE_RT',
        label: { en: 'In Pain Arm Moderate Right' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_CHEST_MILD',
        label: { en: 'In Pain Chest Mild' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_CHEST_MODERATE',
        label: { en: 'In Pain Chest Moderate' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_HEAD_MILD',
        label: { en: 'In Pain Head Mild' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          nonGastricDistension: true
        }
      },
      {
        key: 'IN_PAIN_HEAD_MODERATE',
        label: { en: 'In Pain Head Moderate' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_LEG_MILD_LT',
        label: { en: 'In Pain Leg Mild Left' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_LEG_MILD_RT',
        label: { en: 'In Pain Leg Mild Right' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_LEG_MODERATE_LT',
        label: { en: 'In Pain Leg Moderate Left' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'IN_PAIN_LEG_MODERATE_RT',
        label: { en: 'In Pain Leg Moderate Right' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true
        }
      },
      {
        key: 'TOUCH_FINGERS',
        label: { en: 'Touch Fingers' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: true,
          isOneShot: true,
          isRepeating: true
        }
      },
      {
        key: 'VOMIT',
        label: { en: 'Vomit' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: true,
          isOneShot: true,
          isRepeating: true
        }
      },
      {
        key: 'WAKE_UP_ABRUPT',
        label: { en: 'Wake Up Abrupt' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: true,
          isRepeating: false
        }
      },
      {
        key: 'WAKE_UP_SLOW',
        label: { en: 'Wake Up Slow' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: true,
          isRepeating: false
        }
      },
      {
        key: 'LEG_SUPPORT_LT',
        label: { en: 'Leg Support Left' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          isMilitaryOnly: true,
        }
      },
      {
        key: 'LEG_SUPPORT_RT',
        label: { en: 'Leg Support Right' },
        meta: {
          compatiblePositions: [ 'SIT', 'LAY', 'FOWLER' ],
          hasRepeatDelay: false,
          isOneShot: false,
          isRepeating: true,
          isMilitaryOnly: true,
        }
      },
    ],
    type: 'enum',
    defaultValue: 'IDLE'
  },
  {
    category: 'vital',
    id: 'spo2',
    key: 'SPO2',
    name: { en: 'SPO2', es: 'SpO2' },
    order: 5,
    possibleValues: null,
    type: 'number',
    defaultValue: 100,
    maxValue: 100
  },
  {
    id: 'complexion',
    name: { en: 'Skin Condition' },
    key: 'COMPLEXION',
    possibleValues: [
      { key: 'NORMAL', label: { en: 'Normal' } },
      { key: 'PALE_SMALL', label: { en: 'Pale Mild' } },
      { key: 'PALE', label: { en: 'Pale Moderate' } },
      { key: 'JAUNDICE_SMALL', label: { en: 'Jaundice Mild' } },
      { key: 'JAUNDICE', label: { en: 'Jaundice Moderate' } },
      { key: 'DIAPHORETIC_SMALL', label: { en: 'Diaphoretic Mild' } },
      { key: 'DIAPHORETIC', label: { en: 'Diaphoretic Moderate' } },
      { key: 'DIAPHORETIC_LARGE', label: { en: 'Diaphoretic Severe' } },
      { key: 'FLUSH', label: { en: 'Flushed' } },
      { key: 'CYANOSIS', label: { en: 'Cyanosis Moderate' }},
      { key: 'CYANOSIS_LARGE', label: { en: 'Cyanosis Severe' }},
      { key: 'MOTTLED_SKIN', label: { en: 'Mottled Moderate' }},
      { key: 'MOTTLED_SKIN_LARGE', label: { en: 'Mottled Severe' }},
    ],
    type: 'enum',
    defaultValue: 'NORMAL'
  }
]
